import React from "react";
import Comingsoonpage from "../../../common/Comingsoon";

const StaffManagement = () => {
  return (
    <div>
      <Comingsoonpage />
    </div>
  );
};

export default StaffManagement;
